<template>
  <v-card max-width="350" >
    <v-row v-if="!isMobile() && clubLogo" no-gutters class="pa-4">
      <!-- 3:2 aspect ratio for the club logo  -->
      <v-img height="233" width="300" :src="base64ImgPrefix + clubLogo"></v-img>
    </v-row>
    <!-- title -->
    <v-card-title>
      <div v-html="$t('loginForm.login_title')" />
    </v-card-title>

    <!-- description / subtitle -->
    <v-card-subtitle>{{ $t('loginForm.login_subTitle') }} </v-card-subtitle>

    <!-- input fields -->
    <v-form ref="loginRegisterForm">
      <v-row no-gutters justify="start">
        <v-row no-gutters class="ma-2 flex-column" style="max-width: 475px" align="center">
          <v-col>
            <!-- addressnumber -->
            <v-text-field
              v-model="loginData.login"
              @keydown.enter="handleLogin"
              :label="$t('common.label_addressNumber')"
              :rules="commonRules"
              prepend-icon="mdi-account"
              clearable />
          </v-col>
          <v-col>
            <!-- password input -->
            <v-text-field
              v-model="loginData.password"
              @keydown.enter="handleLogin"
              @click:append="loginData.showPassword = !loginData.showPassword"
              :label="$t('common.label_password')"
              :type="loginData.showPassword ? 'text' : 'password'"
              :append-icon="loginData.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="commonRules"
              prepend-icon="mdi-key"
              clearable
              :hint="showRegistrationFields ? $t('loginForm.register_password_info') : ''"
              :persistent-hint="showRegistrationFields" />
          </v-col>
        </v-row>
      </v-row>

      <!-- errors -->
      <v-row no-gutters class="ma-2" v-if="errors.length > 0">
        <Detail :containerNoPadding="true" :title="$t('common.label_errorOccured')">
          <template slot="header">
            <v-list-item-title> <div v-text="$t('common.label_errorOccured')" /> </v-list-item-title>
            <v-list-item-subtitle v-for="error in errors" :key="error" class="red--text" style="white-space: pre-line">
              {{ error }}
            </v-list-item-subtitle>
          </template>
        </Detail>
      </v-row>

      <!-- address number informations -->
      <v-row no-gutters class="ma-2" justify="center">
        <Detail
          :containerNoPadding="true"
          :title="$t('loginForm.login_addressNr_title')"
          :subTitle="$t('loginForm.login_addressNr_description')"></Detail>
      </v-row>
    </v-form>

    <v-card-actions>
      <v-row no-gutters class="ma-2" justify="end" align="end">
        <!-- login button -->
        <v-btn @click="handleLogin" :loading="loading" color="primary white--text">
          {{ $t('loginForm.login_action_login') }}
          <v-icon right> mdi-login </v-icon>
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
// Api
import { Api } from '@/api/apiAccess.ts';
// mixins
import Helpers from '@/mixins/helpers.js';
import Validation from '@/mixins/validationRules.js';
// components
import Detail from '@/components/controls/Detail.vue';
import ApplicationWrapper from '@/components/controls/ApplicationWrapper.vue';

export default {
  name: 'LoginForm',

  emits: ['onLoginSubmit', 'onRegisterSubmit', 'onAddressNumberSubmit'],

  mixins: [Helpers, Validation],

  components: { Detail },

  props: {
    showRegistrationFields: Boolean,
    loading: Boolean,
    stepToShow: Number,
    errors: Array,
  },

  data: function () {
    return {
      clubLogo: undefined,
      registrationStep: 1,
      loginData: {
        // form inputs
        login: '',
        password: '',
        passwordRepeat: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        addressNumber: undefined,
        // register form vars
        showPassword: false,
        showPasswordRepeat: false,
      },
    };
  },

  mounted: async function () {
    try {
      var clubData = (await Api.HaKuBu.haKuBuGetClubData(500, 500, this.$route.params.clubId)).data;
      if (!clubData || !clubData.Logo) return;
      this.clubLogo = clubData.Logo;
    } catch (error) {
      this.$root.snackbar.show(this.$root.snackbars.genericError);
      this.configurationOk = 1;
      return;
    }
  },
  methods: {
    // #region eventhandlers
    /** handles the click on the "Registrieren" button in the registration form */
    handleRegistration() {
      if (this.$refs.loginRegisterForm.validate()) this.$emit('onRegisterSubmit', this.loginData);
    },

    /** handles the click on the "Anmelden" button in the login form */
    handleLogin() {
      if (this.$refs.loginRegisterForm.validate()) this.$emit('onLoginSubmit', this.loginData);
    },

    /** handles the input from the date picker */
    handleDateInput(date) {
      // format date
      date = this.$d(new Date(date), 'longDate');

      this.loginData.birthDate = date;
    },

    handleAddressNumberSubmit() {
      this.$emit('onAddressNumberSubmit', this.loginData);
    },
    //#endregion
  },

  computed: {
    passwordRepeatRules() {
      return [
        this.loginData.password == this.loginData.passwordRepeat || this.$t('validation.password_mustMatch'),
        this.loginData.password !== this.loginData.login || this.$t('validation.password_noMailAsPw'),
        this.loginData.passwordRepeat !== this.loginData.login || this.$t('validation.password_noMailAsPw'),
      ];
    },
  },
};
</script>
